import React from 'react';
import classNames from 'classnames';
import RichText from '../RichText';
import GlImage from '../Image';
import { getImageData } from '../../utils/contentful';
import { IMultiUpListFields } from '../../../types/contentful';

interface Props extends IMultiUpListFields {
  sysId?: string;
}

export function MultiUpList({ headline, items, sysId }: Props) {
  return (
    <section
      className="flex flex-col justify-items-center py-container tablet:px-12"
      id={sysId}
      data-testid="multi-up-list"
    >
      <div className="mx-auto flex max-w-screen-max flex-col px-4">
        {headline && (
          <h2 className="mx-auto mb-6 mt-12 py-4 text-center text-[28px] font-medium tablet:text-[42px]">
            {headline}
          </h2>
        )}
        <div className="mx-auto flex flex-row flex-wrap justify-center gap-10 py-4 tablet:gap-0 tablet:gap-y-10 desktop:flex-nowrap desktop:gap-10 max:max-w-[83.3%]">
          {items.map(({ sys, fields }) => {
            return (
              <div
                key={sys.id}
                className={classNames(
                  'flex items-center gap-6 px-3 text-center tablet:flex-col tablet:gap-5 tablet:px-5',
                  {
                    'tablet:w-1/2 desktop:w-1/4': items.length === 4,
                    'tablet:w-1/3': items.length === 3,
                    'tablet:w-1/2': items.length === 2
                  }
                )}
                data-testid="multi-up-list-item"
              >
                <div className="flex max-h-[186px] max-w-[186px] flex-shrink-0 tiny:max-tablet:w-28 tablet:max-h-full tablet:max-w-full [&_span]:!m-auto">
                  <GlImage
                    {...getImageData(fields.image)}
                    width={220}
                    height={220}
                    layout="intrinsic"
                    className="m-auto"
                  />
                </div>
                <div className="h-fit text-left tablet:max-w-full">
                  <h3 className="mb-2 text-xl font-medium leading-6 tablet:text-2xl">
                    {fields.headline}
                  </h3>
                  {fields.body && <RichText data={fields.body} />}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
